
import { CandidatesSearch } from "@/components/candidates/CandidatesSearch";
import { useCandidatesFilter } from "@/contexts/CandidatesFilterContext";

interface CandidatesFilterWrapperProps {
  allSkills: string[];
  allStatuses: string[];
}

export const CandidatesFilterWrapper = ({
  allSkills,
  allStatuses
}: CandidatesFilterWrapperProps) => {
  const {
    searchTerm,
    setSearchTerm,
    skillsFilter,
    setSkillsFilter,
    statusFilter,
    setStatusFilter,
    functionFilter,
    setFunctionFilter,
    currentPage,
    setCurrentPage
  } = useCandidatesFilter();

  // Reset to first page when filters change
  const handleSearchTermChange = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };

  const handleSkillsFilterChange = (skills: string[]) => {
    setSkillsFilter(skills);
    setCurrentPage(1);
  };

  const handleStatusFilterChange = (statuses: string[]) => {
    setStatusFilter(statuses);
    setCurrentPage(1);
  };

  const handleFunctionFilterChange = (functionName: string) => {
    setFunctionFilter(functionName);
    setCurrentPage(1);
  };

  return (
    <CandidatesSearch 
      searchTerm={searchTerm}
      setSearchTerm={handleSearchTermChange}
      skillsFilter={skillsFilter}
      setSkillsFilter={handleSkillsFilterChange}
      statusFilter={statusFilter}
      setStatusFilter={handleStatusFilterChange}
      functionFilter={functionFilter}
      setFunctionFilter={handleFunctionFilterChange}
      allSkills={allSkills}
      allStatuses={allStatuses}
    />
  );
};
